import React from 'react';
import { PlanSelectProvider } from './service/plan-select-service';
import { CurrentPlan, PaymentMethod, Plan } from './types';
import PlanSelect from './plan-select';

interface Props {
  defaultPaymentMethod?: PaymentMethod;
  currentPlan: CurrentPlan;
  minConversionLicenses: number;
  plans: Plan[];
}

const Plans: React.FC<Props> = ({
  defaultPaymentMethod, currentPlan, minConversionLicenses, plans,
}) => (
  <PlanSelectProvider
    currentPlan={currentPlan}
    defaultPaymentMethod={defaultPaymentMethod}
    minConversionLicenses={minConversionLicenses}
    plans={plans}
  >
    <PlanSelect />
  </PlanSelectProvider>
);

export default Plans;
